import { render, staticRenderFns } from "./PickupRoadmapShow.vue?vue&type=template&id=2abd8aa3&scoped=true&"
import script from "./PickupRoadmapShow.vue?vue&type=script&lang=js&"
export * from "./PickupRoadmapShow.vue?vue&type=script&lang=js&"
import style0 from "./PickupRoadmapShow.vue?vue&type=style&index=0&id=2abd8aa3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2abd8aa3",
  null
  
)

export default component.exports